import React from "react";
import './index.css';
import { appRootReducer } from "./features/setup/appRootReducer";
import { Provider } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { useTheme, useVariables } from "./features/context/CustomerContext";
import styled from "styled-components";
import { BaseApp } from "./framework/components/main/BaseApp";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({ reducer: appRootReducer });

const AppWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-family: Arial;
    font-size: 16px;
    height: 100vh;
    @media screen and (min-width: ${(props) => props.theme.mobileMenuBreakpoint}px) {  
        background-color: ${(props) => props.theme.brandColor2};
        overflow-x: hidden;
    }
    overflow: hidden;
`

const App: React.FC = () => {
    const theme = useTheme();
    const variables = useVariables();

    const oidcConfig = {
        authority:`${variables?.KEYCLOAK_BASE_PATH}/realms/${variables?.realmName}`,
        client_id: `${variables?.KEYCLOAK_CLIENT_ID}`,
        redirect_uri: window.location.href,
        post_logout_redirect_uri: `${variables.LOGOUT_URL}`,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        onSigninCallback: () => { window.history.replaceState({}, document.title, window.location.pathname)},
        automaticSilentRenew: false
    };

    return (
        <AuthProvider {...oidcConfig}>
            <Provider store={store}>
                <AppWrapper theme={theme}>
                    <BaseApp />
                </AppWrapper>
            </Provider>
        </AuthProvider>
    );
}

export default App;